export const organisationExcelHeaders = [
  { label: 'Id', key: 'id' },
  { label: 'District', key: 'ref_district.name' },
  { label: 'Registration Number', key: 'registration_number' },
  // { label: 'Atom Id', key: 'atom_id' },
  { label: 'Insitution Name', key: 'name_of_organization' },
  { label: 'User Type', key: 'user_category_sub_type.sub_category_name' },
  { label: 'Official Email Address', key: 'email' },
  { label: 'Official Mobile Number', key: 'mobile' },
  { label: 'Contact Person Name', key: 'contact_person_name' },
  { label: 'Contact Person Email', key: 'contact_person_email' },
  { label: 'Contact Person Mobile Number', key: 'contact_person_contact' },
 
 
  
];